"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContext = void 0;
const bridge_1 = require("../bridge");
const i18n_1 = require("@forge/i18n");
const callBridge = (0, bridge_1.getCallBridge)();
const getContext = async () => {
    var _a;
    const context = await callBridge('getContext');
    const locale = context === null || context === void 0 ? void 0 : context.locale;
    if (locale) {
        context.locale = (_a = (0, i18n_1.ensureLocale)(locale)) !== null && _a !== void 0 ? _a : locale;
    }
    return context;
};
exports.getContext = getContext;
